<ng-container [formGroup]="form">
  <span class="label">Type d'affectation : </span>
  @let typeChanged = typeChange();
  <mat-radio-group
    aria-label="Sélectionner le type d'affectation"
    class="assignment-type"
    [class.changed]="!!typeChanged"
    [matTooltip]="typeChanged"
    (change)="onAssignmentTypeChange($event)"
    formControlName="assignmentType"
    [required]="validation()"
  >
    <mat-radio-button value="SPECIFIC">Spécifique</mat-radio-button>
    <mat-radio-button value="TOURNEE">Tournée</mat-radio-button>
  </mat-radio-group>

  @if (form.controls.assignmentType.value === 'SPECIFIC') {
    <section>
      <h3>Résidences</h3>

      <div class="residencies">
        @for (residency of form.controls.residencies.controls; track $index) {
          @let residencyChanged = residencyChange($index);
          <div
            class="residency"
            [class.changed]="!!residencyChanged"
            [matTooltip]="residencyChanged"
          >
            <div class="actions">
              @if (form.controls.residencies.controls.length > 1) {
                <button
                  matIconButton
                  color="warn"
                  (click)="removeResidency($index)"
                  [disabled]="readOnly()"
                >
                  <mat-icon>delete_forever</mat-icon>
                </button>
              } @else {
                <div></div>
              }
            </div>
            <app-residency-address-form
              [required]="validation()"
              [disabled]="readOnly()"
              [formGroup]="residency"
            ></app-residency-address-form>
          </div>
        }
      </div>
      @for (label of removedResidencies(); track label) {
        <p class="removed">Retirée par l'avenant : {{ label }}</p>
      }
      <button
        matButton
        color="primary"
        (click)="addResidency()"
        matTooltip="Ajouter une résidence"
        [disabled]="readOnly()"
      >
        <mat-icon>add_location_alt</mat-icon>
        <span>Ajouter une résidence</span>
      </button>
    </section>
  }
</ng-container>
